import React from 'react';

/* Utils. */
import classnames from 'classnames';

/* Styles */
import css from './nibText.module.sass';

/*
 * type = secondary || accent || dark || light || error
 * size = small(80%) || smallMedium(90%) || medium(100%) || mediumLarge(110%) || large(120%)
 * align = left || center || right || justify
 */

const NibText = ({ children, type = 'secondary', size = 'small', style = {}, align = 'left', className, ...props }) => {
  return (
    <p
      className={classnames(css.text, className && className, css[size], css[type])}
      style={{ textAlign: align, ...style }}
      {...props}
    >
      {children}
    </p>
  );
};

export default NibText;
